import { render, staticRenderFns } from "./NewModel.vue?vue&type=template&id=2d5f5c5d&scoped=true&"
import script from "./NewModel.vue?vue&type=script&lang=js&"
export * from "./NewModel.vue?vue&type=script&lang=js&"
import style0 from "./NewModel.vue?vue&type=style&index=0&id=2d5f5c5d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5f5c5d",
  null
  
)

export default component.exports